import $ from 'jquery';
import 'bootstrap';
import 'owl.carousel';
import './custom';
import './menu-mobile';
import './modals';
import './modal-form-search';
import css from '../scss/app.scss';
import "@fancyapps/ui/dist/fancybox.css";

import {
    Fancybox,
    Carousel
} from "@fancyapps/ui";
/*--------------*/

jQuery(function () {
    // Initialise Carousel
    if ($('#mainCarousel').length) {

        const mainCarousel = new Carousel(document.querySelector("#mainCarousel"), {
            Dots: true,
            arrows: false,
            slidesPerPage: 1,
            slides: 1,
            infinite: false,
            margin: 0,
            autoSize: false
        });

        // Customize Fancybox
        Fancybox.bind('[data-fancybox="gallery"]', {
            Carousel: {
                on: {
                    change: (that) => {
                        mainCarousel.slideTo(mainCarousel.findPageForSlide(that.page), {
                            friction: 0,
                        });
                    },
                },
            },
        });

    }
    $('.owl-carousel-1').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        touchDrag: false,
        mouseDrag: false,
        pullDrag: false,
        responsive: {
            0: {
                items: 1
            },
        }
    })

    $('.owl-carousel-3').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            640: {
                items: 3
            }
        }
    })

    $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
            $("#img-logo").addClass("replier");
        } else {
            $("#img-logo").removeClass("replier");
        }
    });

    // Flèche "next" management du click
    $(".arrow-next-carousel").on("click", function () {
        $("#slider-mise-en-avant .owl-carousel-1 .owl-next").click();
    })

    $(".arrow-next-carousel-presentation").on("click", function () {
        $("#slide_presentation_oeuvre.owl-carousel-1 .owl-next").click();
    })

    $("#slider-grande-oeuvre .arrow-right").on("click", function () {
        $("#slider-grande-oeuvre .owl-carousel-1 .owl-next").click();
    })

    // Gestion des affichages pour les menus sur le coté
    $(".show-vente").on("click", function () {
        if ($('#vente-in-progress').hasClass('active')) {
            $('#vente-in-progress').removeClass("active");
            $("#vente-in-progress .arrow-left").show();
        } else {
            $('#vente-in-progress').addClass("active");
            $("#menu-estimation .container").css("margin-left", "auto");
            $("#menu-estimation").removeClass("active");
            $("#menu-estimation .arrow-left").show();
            $("#calendar-vente .container").css("margin-left", "auto");
            $("#calendar-vente").removeClass("active");
            $("#calendar-vente .arrow-left").show();
        }
    });


    $("#calendar-vente .arrow-left").on("click", function () {
        $("#calendar-vente").css("left", "100%");
        $("#calendar-vente .container").css("margin-left", "auto");
        $("#calendar-vente").removeClass("active");
        $("#calendar-vente .arrow-left").show();
    });

    $(".open-alerte-calendar").on("click", function () {
        $('#vente-in-progress').css("left", "100%");
        $("#vente-in-progress .container").css("margin-left", "auto");
        $('#vente-in-progress').removeClass("active");
        $("#vente-in-progress .arrow-left").show();
        $("#menu-estimation").removeClass("active");
        $("#calendar-vente").css("right", "0");
        $("#calendar-vente").addClass("active");
    });


    $("#menu-desktop > .menu-item > .sub-menu").on("click", function (e) {
        e.stopPropagation();
    });

    // Ouverture du Modal seulement si addresse mail valide
    $("#launchMailchimpModal").on("click", function (e) {
        if (!validateEmail($("[name='newsletter_mail']").val())) {
            e.stopPropagation();
        } else {
            $("[name='mailchimp_hiddenmail']").val($("[name='newsletter_mail']").val());
        }
    });

    // Evenement déclencheur de création des alertes vente
    $(".submit-alerte-creation").on("click", function () {
        $(".create_alerte").each(function () {
            if ($(this).prop('checked')) {

                var data = $(this).val().split("|");

                if (data[0] !== 0) {

                    // Requête AJAX
                    jQuery.post(
                        ajaxurl, {
                            'action': 'add_alerte_vente',
                            'user_id': data[0],
                            'id_vente': data[1],
                            'date_alerte': data[2]
                        },
                        function (response) {

                        }
                    );

                } else {
                    //TODO fenetre message user non logué
                }

            }
        });
    });

    // Evenement de suppression d'une alerte
    $(".delete-alert-ajax").on("click", function () {
        if (confirm("Etes-vous sûr de vouloir supprimer cette alerte ?")) {
            jQuery.post(
                ajaxurl, {
                    'action': 'remove_alerte_vente',
                    'id_alerte': $(this).attr("data")
                },
                function (response) {
                    if (response == "OK") {
                        $(this).parent("td").fadeOut(1000);
                    }
                }
            )
        }
    });

    $("#submitOrdreAchat").on("click", function () {
        addBuyOrder($("#launchOrdreAchat").attr("data-product"), $("#price-ordre-achat").val());
        $('.toast-add-offre').toast('show');
    });

    $(".btn-delete-offre-achat").on("click", function () {
        deleteBuyOrder($(this).attr("data-product"));
        $(this).parent(".ordre-achat-container").fadeOut();
    });

    /*--------------*/
});

// Gestion des boutons ronds du slider de la page single oeuvre
$(document).on("click", '.switch-slide', function () {
    if ($('#slide_show_oeuvre')) {
        $('#slide_show_oeuvre').trigger('to.owl.carousel', ($(this).attr("target") - 1));
    }
    if ($('#slide_presentation_oeuvre')) {
        $('#slide_presentation_oeuvre').trigger('to.owl.carousel', ($(this).attr("target") - 1));
    }
});



// Check validité de l'email fourni
const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};
//Charge la liste des categories via ajax
function loadCategoryList() {

    jQuery.post(
        ajaxurl, {
            'action': 'load_category_oeuvres',
            "vente": vente, //eslint-disable-line
        },
        function (response) {
            var content = JSON.parse(response);
            $("#category-search-bar").append(content.category);
            $("#lot-selector").append(content.lots);
            $("#count-qty-lot").empty();
            $("#count-qty-lot").append(content.qty + " Lots");
        }
    );
}


// Update ordre d'achat
function addBuyOrder(id_Oeuvre, price) {

    jQuery.post(
        ajaxurl, {
            'action': 'add_ordre_achat',
            'oeuvre_id': id_Oeuvre,
            'prix_offre': price
        },
        function (response) {
            console.log(response)
        }
    );
}

// Update ordre d'achat
function deleteBuyOrder(id_Oeuvre) {

    jQuery.post(
        ajaxurl, {
            'action': 'delete_ordre_achat',
            'oeuvre_id': id_Oeuvre,
        },
        function (response) {
            console.log(id_Oeuvre);
        }
    );
}

// Button menu deroulant

// Evenement produisant le zoom
$("#slide_presentation_oeuvre .img-slide").on("mouseover", function () {

});

// Ancre smooth scrolling
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

// Fonction zoom sur image oeuvre
$(".zoom").on("mousemove", function (e) {
    var mobile = detectMobile();
    if (mobile === false) {
        zoom(e);
    } else {
        $(".zoom").removeClass('zoom');
    }
});

// Fonction zoom sur image oeuvre sur mobile
$(".zoom").on("touchmove", function (e) {
    var mobile = detectMobile();
    if (mobile === false) {
        zoom(e);
    } else {
        $(".zoom").removeClass('zoom');
    }
});

$(".zoom-container").on("touchmove", function (e) {
    e.preventDefault();
});

function zoom(e) {
    var x, y, offsetX, offsetY;
    var zoomer = e.currentTarget;
    if (e.offsetX) {
        offsetX = e.offsetX;
    } else {
        offsetX = e.originalEvent.changedTouches[0].clientX;
    }

    if (e.offsetY) {
        offsetY = e.offsetY;
    } else {
        offsetY = e.originalEvent.changedTouches[0].clientY;
    }
    x = offsetX / zoomer.offsetWidth * 100;
    y = offsetY / zoomer.offsetHeight * 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

function detectMobile() {
    return ((window.innerWidth <= 800) || (window.innerHeight <= 600));
}